export const flowTeamUpZH = {
  flowTeamUp1: '加入团队',
  flowTeamUp2: '创建团队',
  flowTeamUp3: '全部',
  flowTeamUp4: '创建',
  flowTeamUp5: '加入',
  flowTeamUp6: '人已加入',
  flowTeamUp7: '已退出',
  flowTeamUp8: '已解散',
  flowTeamUp9: '组队中',
  flowTeamUp10: '组队成功',
  flowTeamUp11: '我创建的团队',
  flowTeamUp12: '我加入的团队',
  flowTeamUp13: '组队规则',
  flowTeamUp14: '创建一个自己的团队或申请加入其他团队吧！',
  flowTeamUp15: '组员人数要求为',
  flowTeamUp16: '人',
  flowTeamUp17: '创建一个自己的团队，成为队长',
  flowTeamUp18: '加入其他团队，成为队员',
  flowTeamUp19: '团队名称：',
  flowTeamUp20: '请输入你的团队名称',
  flowTeamUp21: '团队简介：',
  flowTeamUp22: '请输入你的团队简介(选填)',
  flowTeamUp23: '组队作为参与项目的任务之一，学生可以通过自发行为完成组队。',
  flowTeamUp24: '恭喜你，创建团队成功！',
  flowTeamUp25: '进入团队主页，邀请好友',
  flowTeamUp26: '为你的团队起一个耀眼的名称吧',
  flowTeamUp27: '你的组队正在进行中，该功能无法操作',
  flowTeamUp28: '你已加入了团队，只允许创建或加入一个团队',
  flowTeamUp29: '组队',
  flowTeamUp30: '规则',
  flowTeamUp31: '创建一个自己的团队，成为队长或申请加入其他团队，成为队友。团队人数',
  flowTeamUp32: '创建我的团队',
  flowTeamUp33: '搜索你想加入的团队名称',
  flowTeamUp34: '申请加入',
  flowTeamUp35: '已申请',
  flowTeamUp36: '组队作为参与项目的任务之一，学生可以通过自发行为完成组队。组员人数要求为',
  flowTeamUp37: '方式一：创建团队',
  flowTeamUp38: '方式二：加入团队',
  flowTeamUp39: '一、组队方式',
  flowTeamUp40: '二、特权说明',
  flowTeamUp41: '为你的团队起一个耀眼的名称吧！',
  flowTeamUp42: '你可以申请加入下面的团队',
  flowTeamUp43: '确定完成组队',
  flowTeamUp44: '等待队长确定组队',
  flowTeamUp45: '编辑团队',
  flowTeamUp46: '分享邀请',
  flowTeamUp47: '站内邀请',
  flowTeamUp48: '在这里邀请队员加入团队哦！',
  flowTeamUp49: '暂时没有成员',
  flowTeamUp50: '你可能感兴趣的团队',
  flowTeamUp51: '你还没加入团队哦，',
  flowTeamUp52: '确定完成组队吗？',
  flowTeamUp53: '组队成功后，你的队员将不可变更，继续完成后续任务吧！',
  flowTeamUp54: '团队编号：',
  flowTeamUp55: '所属学校：',
  flowTeamUp56: '编辑资料',
  flowTeamUp57: '动态',
  flowTeamUp58: '，有什么想分享给伙伴们的？',
  flowTeamUp59: '记录你的成长',
  flowTeamUp60: '暂时没有动态',
  flowTeamUp61: '团队成员',
  flowTeamUp62: '队长',
  flowTeamUp63: '编辑团队',
  flowTeamUp64: '退出团队',
  flowTeamUp65: '查看组队任务',
  flowTeamUp66: '更换队长',
  flowTeamUp67: '更换',
  flowTeamUp68: '解散团队',
  flowTeamUp69: '请确保你想邀请的小伙伴已经注册Bloom账号，邀请加入后将发送邀请短信和邀请消息，请通知小伙伴在「手机短信」或「活动消息」查看和接受邀请。',
  flowTeamUp70: '搜索你想邀请的人（手机号/姓名）',
  flowTeamUp71: '邀请加入',
  flowTeamUp72: '已邀请',
  flowTeamUp73: '很抱歉，该用户不存在',
  flowTeamUp74: '使用微信/QQ “扫一扫”',
  flowTeamUp75: '打开网页后点击右上角"···"分享给好友',
  flowTeamUp76: '复制链接',
  flowTeamUp77: '搜索你想邀请的人（注册手机号/姓名）',
  flowTeamUp78: '所属学校将用于团队活动环节，在',
  flowTeamUp79: '之前可以修改1次。',
  flowTeamUp80: '请选择所属学校',
  flowTeamUp81: '所属学校',
  flowTeamUp82: '编辑资料',
  flowTeamUp83: '解散团队，你需要重新再次创建团队或接受邀请加入其他团队！',
  flowTeamUp84: '确定退出团队吗？',
  flowTeamUp85: '确认移除该队员？',
  flowTeamUp86: '确定解散团队吗？',
  flowTeamUp87: '更换成功',
  flowTeamUp88: '退出团队成功',
  flowTeamUp89: '不能邀请自己',
  flowTeamUp90: '邀请成功',
  flowTeamUp91: '复制失败，请重试',
  flowTeamUp92: '复制成功',
  flowTeamUp93: '至少说点什么吧',
  flowTeamUp94: '你确定要删除自己的动态吗？',
  flowTeamUp95: '删除成功!',
  flowTeamUp96: '创建团队是以队长身份创建团队，并邀请队员加入团队。邀请方式是通过团队主页的分享邀请，将邀请链接分享给队员，队员加入成功后，队长确定完成组队即视为组队成功',
  flowTeamUp97: '邀请队员',
  flowTeamUp98: '确定组队',
  flowTeamUp99: '加入团队是以队员身份接受邀请并加入其他团队。加入方式是接受邀请人发送的邀请链接，通过链接接受邀请或通过活动消息页面接受邀请，加入成功后，等待队长确定完成组队。',
  flowTeamUp100: '队长确定组队',
  flowTeamUp101: '接受邀请',
  flowTeamUp102: '搜索你想加入的团队（团队名称）',
  flowTeamUp103: '组队状态',
  flowTeamUp104: '发布成功',
  flowTeamUp105: '修改所属学校',
  flowTeamUp106: '等待确定组队',
  flowTeamUp107: '我的团队成员',
  flowTeamUp108: '查看活动任务',
  flowTeamUp109: '了解更多',
  flowTeamUp110: '分享',
  flowTeamUp111: '进入 Bloom',
  flowTeamUp112: '解散团队，整个队伍将被解散！',
  flowTeamUp113: '网络出问题了，请刷新页面',
  flowTeamUp114: '邀请你加入我的团队，一起参加',
  flowTeamUp115: '创建成功',
  flowTeamUp116: '移除',
  flowTeamUp117: '移除团队成员',
  flowTeamUp118: '分享链接'
}

export const flowTeamUpEN = {
  flowTeamUp1: 'Join the team',
  flowTeamUp2: 'Create a team',
  flowTeamUp3: 'All',
  flowTeamUp4: 'Create',
  flowTeamUp5: 'Join',
  flowTeamUp6: ' people have joined',
  flowTeamUp7: 'Quit',
  flowTeamUp8: 'Dismissed',
  flowTeamUp9: 'Team in progress',
  flowTeamUp10: 'Team completed',
  flowTeamUp11: 'The team I created',
  flowTeamUp12: 'The team I joined',
  flowTeamUp13: 'Team Rules',
  flowTeamUp14: 'Create your own team or apply to join another team!',
  flowTeamUp15: 'The number of team members is required to be ',
  flowTeamUp16: 'people',
  flowTeamUp17: 'Create your own team and become a team leader',
  flowTeamUp18: 'Join other teams and become a team member',
  flowTeamUp19: 'Team Name',
  flowTeamUp20: 'Please enter the name of your team',
  flowTeamUp21: 'Team Profile',
  flowTeamUp22: 'Please enter your team profile (optional)',
  flowTeamUp23: 'Being in a team is one of the tasks involved in the project, and students can create a team among themselves',
  flowTeamUp24: 'Congratulations, you have succeeded in creating a team!',
  flowTeamUp25: 'Go to the team homepage and invite friends',
  flowTeamUp26: 'Give your team a catchy name',
  flowTeamUp27: 'Your team is not created yet and the feature is not available',
  flowTeamUp28: `You're already on a team, and you're only allowed to create or join one team`,
  flowTeamUp29: 'Form a team',
  flowTeamUp30: 'Rules',
  flowTeamUp31: 'Create your own team, become a team leader or apply to join another team and become a teammate. Number of team members ',
  flowTeamUp32: 'Create my team',
  flowTeamUp33: 'Search for the name of the team you want to join',
  flowTeamUp34: 'Apply to join',
  flowTeamUp35: 'Applied',
  flowTeamUp36: 'Teaming is one of the tasks involved in the project, and students can complete the team by spontaneous behavior. The number of team members is required to be ',
  flowTeamUp37: 'Option One: Create a team',
  flowTeamUp38: 'Option Two: Join a team',
  flowTeamUp39: 'I. How to Team-up',
  flowTeamUp40: 'II. Privilege Declaration',
  flowTeamUp41: '1. Give your team a catchy name! ',
  flowTeamUp42: ' You can apply for the teams below',
  flowTeamUp43: 'Confirm teaming',
  flowTeamUp44: 'Waiting for confirm the team',
  flowTeamUp45: 'Edit the team',
  flowTeamUp46: 'Share the invitation',
  flowTeamUp47: 'Invitation within this website',
  flowTeamUp48: 'Invite members to join the team here!',
  flowTeamUp49: 'No member yet',
  flowTeamUp50: 'Teams that you may be interested in',
  flowTeamUp51: `You haven’t joined a team yet.`,
  flowTeamUp52: 'Are you sure you want to create the team?',
  flowTeamUp53: 'Your team members are not allowed to change after the team is created. Please continue to complete the following tasks!',
  flowTeamUp54: 'Team number:',
  flowTeamUp55: 'School:',
  flowTeamUp56: 'Edit profile',
  flowTeamUp57: 'Posts',
  flowTeamUp58: ', Is there anything that you want to share with your friends?',
  flowTeamUp59: 'Record your growth',
  flowTeamUp60: 'No post yet',
  flowTeamUp61: 'Team member',
  flowTeamUp62: 'Team leader',
  flowTeamUp63: 'Edit the team',
  flowTeamUp64: 'Quit the team',
  flowTeamUp65: 'Check team leader’s tasks',
  flowTeamUp66: 'Change team leader',
  flowTeamUp67: 'Change',
  flowTeamUp68: 'Dismiss the team',
  flowTeamUp69: `Please make sure that the partner you want to invite has registered Bloom account. After your invitation, an SMS and a message will be sent to your partner. Please inform your partner to view and accept the invitation in "Mobile SMS" or "Activity Message".`,
  flowTeamUp70: 'Search (registered phone number/name) to invite',
  flowTeamUp71: 'Invite to join',
  flowTeamUp72: 'Invited',
  flowTeamUp73: 'Sorry, the user does not exist',
  flowTeamUp74: `Use WeChat/QQ "Scan"`,
  flowTeamUp75: 'Open the website, and click "..." in the upper right corner to share with friends',
  flowTeamUp76: 'Copy link',
  flowTeamUp77: 'Search (registered phone number/name) to invite',
  flowTeamUp78: 'School is used for the team activities',
  flowTeamUp79: 'Can be edited once before',
  flowTeamUp80: 'Please choose your school',
  flowTeamUp81: 'School',
  flowTeamUp82: 'Edit profile ',
  flowTeamUp83: 'Dismiss the team, and you need to create a new team or join in another team! ',
  flowTeamUp84: 'Are you sure you want to quit the team? ',
  flowTeamUp85: 'Are you sure you want to remove the team member?',
  flowTeamUp86: 'Are you sure you want to dismiss the team?',
  flowTeamUp87: 'Change succeeded ',
  flowTeamUp88: 'Quit the team successfully',
  flowTeamUp89: `Can not invite yourself`,
  flowTeamUp90: 'Invite succeeded',
  flowTeamUp91: 'Copy failed. Please try again',
  flowTeamUp92: 'Copy succeeded',
  flowTeamUp93: 'At least say something',
  flowTeamUp94: 'Are you sure you want to delete your post?',
  flowTeamUp95: 'Deleted successfully! ',
  flowTeamUp96: `Create a team as a team leader and invite members to join the team. Share the invitation link from the team homepage to the members. After the they join the team, the team leader can confirm to complete the team, and the team is created successfully`,
  flowTeamUp97: 'Invite team member ',
  flowTeamUp98: 'Confirm the team',
  flowTeamUp99: 'Joining a team is accepting invitations as a member and join in the team. You can accept the invitation by the shared link or from the activity message. After joining successfully, you should wait for the team leader to confirm the team. ',
  flowTeamUp100: 'The leader confirm the team',
  flowTeamUp101: 'Accept invitation.',
  flowTeamUp102: 'Search the team (team name) you want to join',
  flowTeamUp103: 'Team status',
  flowTeamUp104: 'Publish Successfully',
  flowTeamUp105: 'Modify your school',
  flowTeamUp106: 'Waiting to confirm your team',
  flowTeamUp107: 'My Team Members',
  flowTeamUp108: 'View activity tasks',
  flowTeamUp109: 'Learn More',
  flowTeamUp110: 'Share',
  flowTeamUp111: 'Enter Bloom',
  flowTeamUp112: 'Dismiss the team, and the whole team will be disbanded!',
  flowTeamUp113: 'There is a problem with the network. Please refresh the page',
  flowTeamUp114: 'Invite you to join my team together!',
  flowTeamUp115: 'Created successfully',
  flowTeamUp116: 'remove',
  flowTeamUp117: 'Remove team members',
  flowTeamUp118: 'Share link'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/teamUp.js